import { FolderTree } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Empty } from 'shared/ui';

export const AccountPageEmpty = () => {
	const { t } = useTranslation();

	return (
		<Empty
			icon={<FolderTree />}
			title={t('account-page.empty.title')}
			message={t('account-page.empty.message')}
		/>
	);
};
